<template>
  <div class="ElecInvoice">
    <div class="common-header">
      <es-breadcrumb>
        <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
        <es-breadcrumb-item>{{ $t('查看发票') }}</es-breadcrumb-item>
      </es-breadcrumb>
    </div>
    <divided />
    <div class="body">
      <div class="imgBack" v-loading="loading" :esign-loading-text="$t(`拼命加载中`)">
        <div class="button-wrap">
          <es-button v-if="xmlUrl" type="text" @click="save(xmlUrl)">{{ $t('下载发票') }}(XML)</es-button>
          <es-button v-if="ofdUrl" type="text" @click="save(ofdUrl)">{{ $t('下载发票') }}(OFD)</es-button>
          <es-button type="primary" @click="save(pdfUrl)">{{ $t('下载发票') }}(PDF)</es-button>
        </div>
        <img :src="imgUrl" />
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'
import { mapState } from 'vuex'
import divided from '../../components/divided'

export default {
  components: {
    divided,
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
  },
  data() {
    return {
      pdfUrl: '',
      xmlUrl: '',
      ofdUrl: '',
      imgUrl: '',
      clock: '',
      loading: true,
      number: 0,
      ouid: '',
    }
  },
  destroyed() {
    clearInterval(this.clock)
  },
  created() {
    this.ouid = localStorage.getItem('ouid')
    if (this.$route.query.orderId) {
      this.clock = setInterval(() => {
        this.number = this.number + 1
        const oid = this.userInfo.orgId ? this.userInfo.orgId : this.ouid
        this.$ajax(this.$url.elecInvoicedetail(this.$route.query.orderId, oid)).then(res => {
          if (res.code === 20502002) {
            this.$message.error(res.message)
            clearInterval(this.clock)
            this.$router.push('/Myorder')
          } else if (res.data && res.data.pdfUrl) {
            this.loading = false
            this.pdfUrl = res.data.pdfUrl
            this.imgUrl = res.data.imageUrl
            this.xmlUrl = res.data.xmlUrl
            this.ofdUrl = res.data.ofdUrl
            clearInterval(this.clock)
          } else if (this.number > 10) {
            this.$message({
              type: 'warning',
              message: $t('开票系统维护中，请稍后再试'),
            })
            this.$router.push({
              path: '/MyOrder',
            })
            clearInterval(this.clock)
          }
        })
      }, 2000)
    }
  },
  methods: {
    save(url) {
      window.open(url)
    },
  },
}
</script>
<style scoped>
.button-wrap {
  position: absolute;
  top: 24px;
  right: 24px;
  display: flex;
}
.button-wrap .button {
  text-align: center;
  width: 120px;
  height: 32px;
  color: #fff;
  background: #0975e0ff;
  font-size: 12px;
  line-height: 32px;
  cursor: pointer;
  margin-left: 10px;
}
.imgBack {
  background: #f7f7f7;
  height: 645px;
  margin: 0 auto;
  position: relative;
  text-align: center;
}
.imgBack img {
  margin-top: 100px;
  width: 700px;
  height: 452px;
}
.body {
  padding: 34px 24px;
}
</style>
